import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  getCategoriesResponseSchema,
  getTagsResponseSchema,
  sanitizeTagsRequestSchema,
  sanitizeTagsResponseSchema,
  updateTagsRequestSchema,
  updateTagsResponseSchema,
  treeDataResponseSchema,
} from '../shared/schemas/index.js';

export const treeDataQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/planning/user/tags/tree' as const,
  method: 'GET',
  responseSchema: treeDataResponseSchema,
  querySchema: z.object({
    userId: z.string().optional(),
    mediaPlanId: z.string().optional(),
  }),
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
  processResponse(data) {
    return data;
  },
});

export const categoriesQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/planning/categories' as const,
  method: 'GET',
  responseSchema: getCategoriesResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const mediaPlanTagsQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/planning/media_plans/$mediaPlanId/tags' as const,
  method: 'GET',
  responseSchema: getTagsResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const userTagsQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/planning/user/tags/plain' as const,
  method: 'GET',
  responseSchema: getTagsResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const useUpdateTags = defaultClient.mutation({
  url: 'bff/v2/brands_and_geo/planning/media_plans/$mediaPlanId/tags' as const,
  method: 'PUT',
  requestSchema: updateTagsRequestSchema,
  responseSchema: updateTagsResponseSchema,
  processResponse(data) {
    return data;
  },
});

export const useSanitizeTags = defaultClient.mutation({
  url: 'bff/v2/brands_and_geo/planning/media_plans/sanitize_tags' as const,
  method: 'PUT',
  requestSchema: sanitizeTagsRequestSchema,
  responseSchema: sanitizeTagsResponseSchema,
  processResponse(data) {
    return data;
  },
});
